// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d6e6be55","239":"d423a15b","453":"7dd630a4","732":"46f228bf","762":"918d58fd","857":"1e1be11f"}[chunkId] + ".chunk.js";
};